<!-- Main section -->
<div class="profile-text" *ngIf="profileDataSet?.profileName" id="profileTextDiv">
    <div class="profile-name-title" id="profileNameTitleDiv">{{profileNameValue}}</div>
    <h2 class="profile-name-text">{{profileDataSet?.profileName}}</h2>
</div>
<section class="main_section cp_settings" *ngIf="settingsFrm && !isDataLoading">
    <form [formGroup]="settingsFrm">
        <!-- Settings: Password management -->
        <div class="cp_settings_block" id="passwrdManagement" *ngIf="!this.iposliteEnabled">
            <div class="main_section_headers" id="mainSectionPwdManagement">
                <img alt="upload icon" class="header_icon password_section_img" />
                <span i18n="@@settings.main-section-header.passwords">Passwords</span>
            </div>
            <div class="cp_settings_body password_section" id="pwdSectionDiv"
                style="display: flex; align-items: center">
                <button type="button" class="btn btn-link" (click)="openChangePasswordModal(primary)">
                    <span i18n="@@settings.cp-settings-body.change-master-password">Change Primary Password</span>
                </button>
                <ng-template #popContent2>
                    <div class="popover-upload-req" id="popoverUploadReqDiv">
                        <div class="d-flex align-items-center" id="odaDiv">
                            <span i18n="@@settings.cp-settings-body.change-master-password-popover"
                                class="master-pass-text">This password allows you to access the On-device Admin Console
                                (ODA).</span>
                        </div>
                    </div>
                </ng-template>
                <a class="info_icon" tabindex="0">
                    <img alt="click here to know how to change master password" placement="right" container="body"
                        [ngbPopover]="popContent2" triggers="mouseenter:mouseleave" class="info_circle_icon" />
                </a>
                <button type="button" class="btn btn-link" (click)="openChangePasswordModal(uninstall)">
                    <span i18n="@@settings.cp-settings-body.change-uninstall-password">Change Uninstall Password</span>
                </button>
                <ng-template #popContent>
                    <div class="popover-upload-req" id="popoverUploadReqPasswordUninstallDiv">
                        <div class="d-flex align-items-center" id="popContentDivAlignItemCenterDiv">
                            <span i18n="@@settings.cp-settings-body.change-uninstall-password-popover"
                                class="uninstall-pass-text">This password allows you to uninstall IPOS from a
                                device.</span>
                        </div>
                    </div>
                </ng-template>
                <a class="info_icon" tabindex="0">
                    <img class="info_circle_icon" alt="click here to know how to change master password"
                        placement="right" container="body" [ngbPopover]="popContent" triggers="mouseenter:mouseleave" />
                </a>
            </div>
        </div>

        <!-- Settings: AI assistant -->
        <div class="cp_settings_block" id="aiAssistant" *ngIf="this.iposliteEnabled">
            <div class="main_section_headers">
                <img alt="AI assistant icon" class="ai-assistant-icon terminal" />
                <span>{{globalconst.IPOS_LITE_SUPPRESSVA}}</span>
            </div>
            <div class="cp_settings_body">
                <div id="settingsAI">
                    <label class="mb-0" for="enableSuppressVA">
                        <span>{{globalconst.IPOS_LITE_SUPPRESSVA}}</span>
                    </label>
                    <div id="enableAIassistant" class="custom-control custom-switch mt-0">
                        <input type="checkbox" class="custom-control-input" id="enableAI" [checked]="formCont.enableVA.value"
                            [value]="formCont.enableVA.value" formControlName="enableVA" />
                        <label class="custom-control-label" for="enableAI">
                            {{formCont?.enableVA?.value ? enabled : disabled}}
                        </label>
                    </div>
                </div>
            </div>
        </div>
        
        <!-- Settings: Product Mapping template -->
        <div class="cp_settings_block" id="productMappingTemplate" *ngIf="this.iposliteEnabled">
            <div class="main_section_headers">
                <img alt="upload icon" class="upload-icon terminal" />
                <span>{{uploadTemplateText}}</span>
            </div>
            <div class="cp_settings_body">
                <p><strong>1.</strong>&nbsp; <span><a (click)="downloadPMFile()"
                            class="download_template_link">{{downloadTemplateText}}</a></span>
                </p>
                <p><strong>2.</strong>&nbsp;<span i18n="@@stores.store-user.csv-upload-comp-template">Upload and submit the
                        completed template:</span>
                    <br>&nbsp;<span>{{templateNoteText}}</span>
                </p>
                <label class="upload-margin">
                    <input #templateInput type="file" id="file-picker" accept=".xlsx" (change)="uploadTemplate($event)"
                        hidden />
                    <span class="btn btn-primary upload-btn-grp">
                        <span class="upload_cloud_white_icon"></span>
                        <span class="upload-template" i18n="@@standard-download.ipos-lite.upload-template">Upload
                            Template</span>
                    </span>
                </label>
                <div *ngIf="showXlsxError" id="errorMsgFormat">
                    <span class="text-danger" i18n="@@standard-download.ipos-lite.file-in-xlsx">File must be in .xlsx
                        format.</span>
                </div>
                <div *ngIf="showFileContentError" id="errorMsgName">
                    <span class="text-danger" i18n="@@standard-download.ipos-lite.file-content-not-match">File contents not
                        matching.</span>
                </div>
                <div class="div-alert" *ngIf="!PMFileExists">
                    <span class="alert-box" i18n="@@standard-download.ipos-lite.click-on-upload-template">Clicking on <a>Upload
                            template</a> will replace the existing product mapping file!</span>
                </div>
                <div class="file-name-grp" *ngIf="PMFileExists">
                    <button class="btn btn-outline-primary file-name">
                        <span>{{templateName}}</span>
                    </button>
                    <div class="download_icon" [ngbTooltip]="downloadMessage" triggers="hover" placement="bottom"
                        (click)="downloadModifiedTemplate()"></div>
                </div>
                <div *ngIf="PMFileExists">
                    <span class="upload-date">
                        <span i18n="@@standard-download.ipos-lite.last-updated-on">Last updated on</span>
                        {{uploadedDate | dateFormat: "changeToLocalTimeZone"}}</span>
                </div>
                <ng-template #downloadMessage>
                    <span>{{globalconst.CLICK_DOWNLOAD}}</span>
                </ng-template>
            </div>
        </div>

        <!-- Settings: Upload Data -->
        <div class="cp_settings_block" id="cpSettingsBlockDiv">
            <div class="main_section_headers" id="mainHeaderSetting">
                <img alt="upload icon" class="header_icon terminal" />
                <span>{{globalconst.PROFILE_SKU_IDS_TXT}}</span>
            </div>
            <div class="cp_settings_body" id="cpSettingsBodyDiv">
                <div class="text_items" id="textItemsSettingsDiv">
                    <span>{{globalconst.PROFILE_SKU_SELECT_TXT}}</span>
                    <div *ngIf="this.settings.otherSettings?.skuFileName && this.settings.otherSettings?.skuFileName != ''"
                        id="csvDwnldBtnSettingsDiv">
                        <span class="CSVDwnldBtn" (click)="downloadSKUData()">{{globalconst.CSV_BTN_TXT_3}}</span>
                        <ng-template #popContent3>
                            <div class="popover-upload-req2 p-0" id="popoverUploadSettings">
                                <div class="csvpopover" id="csvSettingsDiv">
                                    <span>{{globalconst.CSV_BTN_TXT_1}}</span>
                                    <div id="brDiv"><br /></div>
                                    <span>{{globalconst.CSV_BTN_TXT_2}}</span>
                                </div>
                            </div>
                        </ng-template>
                        <a class="info_icon" tabindex="0">
                            <img class="info_circle_icon" alt="sku info icon" placement="auto" container="body"
                                [ngbPopover]="popContent3" triggers="mouseenter:mouseleave" />
                        </a>
                    </div>
                </div>

                <div class="sku_id_dropdown" id="skuIdDropDownDiv">
                    <ng-select [items]="skuList" [multiple]="true" bindLabel="publishedName" groupBy="selectedAllGroup"
                        [placeholder]="isAlldevicesSelected ? globalconst.SELECT_ALL_TXT : globalconst.SKU_SELECT_PLACEHLDR"
                        [selectableGroup]="true" [selectableGroupAsModel]="false" [closeOnSelect]="false"
                        bindValue="skuID" [(ngModel)]="selectedSKUs" [ngModelOptions]="{standalone: true}"
                        [clearSearchOnAdd]="true" [searchFn]="SKUSearchFn" (click)="onOpenSkuDropdown($event)"
                        (change)="isSkuSelected($event)">
                        <ng-template ng-optgroup-tmp let-item="item" let-item$="item$" let-index="index">
                            <input id="item-{{index}}" type="checkbox" class="selectAllCheckbox"
                                [ngModel]="item$.selected" [ngModelOptions]="{standalone: true}" />
                            <label for="selectAll"
                                class="select-all-txt"><span>{{globalconst.SELECT_ALL_SKUS_TEXT}}</span></label>
                        </ng-template>
                        <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index"
                            class="ng_selection_template">
                            <div class="d-flex" id="skuIdDFlexDiv">
                                <div class="selectCheckbox" id="checkboxSettingsDiv">
                                    <input id="item-{{index}}" type="checkbox" [ngModel]="item$.selected"
                                        [ngModelOptions]="{standalone: true}" />
                                </div>
                                <div id="itemsSettingDiv">
                                    <div id="publishedNameDiv"><strong>{{item?.publishedName}}</strong></div>
                                    <span class="subtxt">{{item?.internalName}}</span>
                                </div>
                            </div>
                        </ng-template>
                    </ng-select>
                </div>
            </div>
        </div>

        <!-- Settings: Customize comparison -->
        <div class="cp_settings_block" id="customCompareBlockDiv" *ngIf="!this.iposliteEnabled">
            <div class="main_section_headers" id="mainCustomCompareInputDiv">
                <img alt="custom compare icon" class="header_icon terminal" />
                <span i18n="@@create-profile.settings.customize-comp">Customize comparison</span>
            </div>
            <div class="cp_settings_body" id="bodyCustomCompareDiv">
                <span i18n="@@create-profile.settings.menu-item-name">Menu item name</span>&nbsp;<span
                    class="text-danger mr-2">*</span>
                <ng-template #cusCompcontent>
                    <div class="popover-upload-req" id="popoverCompareMenuDiv">
                        <div class="d-flex align-items-center" id="ccTooltipDiv">
                            <span i18n="@@create-profile.settings.customize-comp-menu-item">Customize comparison menu
                                item</span>
                        </div>
                    </div>
                </ng-template>
                <img class="info_circle_icon" alt="hover for help" placement="right" [ngbPopover]="cusCompcontent"
                    triggers="mouseenter:mouseleave" />
                <div class="mt-2 compare-input-style edit-container">
                    <input id="compareTabInput" maxlength="25" class="form-control" type="text" autocomplete="off"
                        [value]="compareNavigationText" [(ngModel)]="compareNavigationText"
                        [ngModelOptions]="{standalone: true}" />
                    <img class="edit-blue-icon" alt="edit icon" />
                </div>
            </div>
        </div>

        <!-- settings: Auto shutdown-->
        <div *ngIf="isAutoShutdownEnabled && !this.iposliteEnabled" class="cp_settings_block" id="autoShutDownMainDiv">
            <div class="main_section_headers" id="autoShutDownEnabledDiv">
                <img alt="auto-shutdown icon" class="header_icon auto_shutdown_icon" />
                <span i18n="@@device-dashboard.auto-heading.auto-shutdown">AUTO-SHUTDOWN</span>
            </div>
            <div class="cp_settings_body" id="cpSetiingsBodyDiv">
                <span i18n="@@ipos-help.oda.setting-autoshut-occur">Shutdown will occur if the device is idle during the
                    last 30 minutes prior to time set but will be extended 30 minutes past last detected
                    activity.</span>
                <div class="custom-control custom-switch mt-2" id="autoShutDownDiv">
                    <input type="checkbox" class="custom-control-input" id="autoshutdown"
                        [checked]="formCont?.autoShutDown?.value" (change)="enableShutdown($event)"
                        [value]="formCont?.autoShutDown?.value" formControlName="autoShutDown" />
                    <label class="custom-control-label" for="autoshutdown">
                        {{formCont?.autoShutDown?.value ? enabled : disabled}}
                    </label>
                </div>
            </div>
            <div *ngIf="formCont.autoShutDown.value" class="time_block" id="autoShutDownValueDiv">
                <div class="timezone" id="timeZoneDiv">
                    <div id="timeZoneHoursDiv"><span i18n="@@device-info.hours-label">Hours</span></div>
                    <div id="timeZoneMintuesDiv"><span i18n="@@retail-hq.minutes">Minutes</span></div>
                </div>
                <iposcen-date-time-zone (isTimeZoneSelected)="checkTimeZone($event)"
                    (defualtTimeZone)="getDefaultTimeZone($event)" [publishDateInfo]="editPublishDateInfo"
                    (getDateTimeZoneData)="getTimeTimeZoneData($event)" [hideCalendar]="true"></iposcen-date-time-zone>
            </div>
            <div *ngIf="!isSettingsTimeZoneSelected" class="formfield_err_msg" id="isSettingTimeZone">
                <span i18n="@@device-dashboard.please-select-timezone.please-select-timezone">Please Select Time
                    zone.</span>
            </div>
        </div>
        <!-- Settings: Price entry toggle -->
        <div *ngIf="!isPriceSupress && !this.iposliteEnabled" class="cp_settings_block" id="settingPriceEntryToggle">
            <div class="main_section_headers" id="mainPriceToggleDiv">
                <img alt="price icon" class="header_icon profile_price_icon" />
                <span i18n="@@settings.main-section-headers.price-entry">Price entry on installation</span>
            </div>
            <div class="cp_settings_body" id="bodyPriceDiv">
                <span i18n="@@settings.main-section-headers.price-entry-info">Allow installers to enter device price
                    during installation.</span>
                <div class="custom-control custom-switch mt-2" id="priceSupressCustomControl">
                    <input type="checkbox" class="custom-control-input" id="priceEntryOnInstall"
                        [checked]="formCont.priceEntryInstallation.value"
                        [value]="formCont.priceEntryInstallation.value" formControlName="priceEntryInstallation" />
                    <label class="custom-control-label" for="priceEntryOnInstall">
                        {{formCont.priceEntryInstallation.value ? enabled : disabled}}
                    </label>
                </div>
            </div>
        </div>

        <!-- Settings: Run on Non-Intel Devices toggle -->
        <div class="cp_settings_block" *ngIf="!isChromebookSelected && !this.iposliteEnabled" id="nonIntelDevicesToggleDiv">
            <div class="main_section_headers" id="nonIntelDevicesToggleDiv1">
                <img alt="non-intel icon" class="header_icon profile_non_intel_icon" />
                <span i18n="@@settings.main-section-headers.non-intel">Run on Non-Intel devices</span>
            </div>
            <div class="cp_settings_body" id="nonIntelDevicesToggleDIv2">
                <span i18n="@@settings.main-section-headers.non-intel-info">Allow IPOS to be installed on non-Intel
                    devices</span>
                <div class="custom-control custom-switch mt-2" id="runNonIntelDiv">
                    <input type="checkbox" class="custom-control-input" id="runOnNonIntel"
                        [checked]="formCont.allowNonIntel.value" [value]="formCont.allowNonIntel.value"
                        formControlName="allowNonIntel" />
                    <label class="custom-control-label" for="runOnNonIntel">
                        {{formCont.allowNonIntel.value ? enabled : disabled}}
                    </label>
                </div>
            </div>
        </div>

        <!-- Settings: Desktop Password Protection toggle -->
        <div class="cp_settings_block" id="desktopPwdProtectionToggle" *ngIf="!this.iposliteEnabled">
            <div class="main_section_headers" id="desktopMainDiv">
                <img alt="desktop password icon" class="header_icon desktop_password_icon" />
                <span i18n="@@settings.main-section-headers.desktop-password">Desktop password protection</span>
            </div>
            <div class="cp_settings_body" id="desktopPwdProtectionMain">
                <span i18n="@@settings.main-section-headers.desktop-password-info">Prevents shoppers from exiting IPOS
                    without a password.</span>
                <div class="custom-control custom-switch mt-2" id="desktoPwdchild">
                    <input type="checkbox" class="custom-control-input" id="desktopPwProtection"
                        [checked]="formCont.desktopPasswordProtection.value"
                        [value]="formCont.desktopPasswordProtection.value" formControlName="desktopPasswordProtection"
                        (change)="updateSettingsFlags($event,'desktop_password_protection')" />
                    <label class="custom-control-label" for="desktopPwProtection">
                        {{formCont.desktopPasswordProtection.value ? enabled : disabled}}
                    </label>
                </div>
            </div>
        </div>
    </form>
    <!-- Settings: Customizable button -->
    <div class="cp_settings_block" *ngIf="!isChromebookSelected && !this.iposliteEnabled" id="customizableButtonMainDiv">
        <div class="main_section_headers" id="customizableButtonChildDiv">
            <img alt="custom-control-input icon" class="header_icon custom_icon" />
            <span i18n="@@settings.main-section-headers.customizable-button">Customizable Button</span>
        </div>
        <div class="cp_settings_body custom_btn_settings" id="customizableButtonMain">
            <div id="customBtnCheckGroupschild">
                <div class="check_groups" id="checkGroupsAnimationBtnDiv">
                    <legend class="col-form-label"><span i18n="@@settings.check-groups.button-animation">Button
                            Animation</span></legend>
                    <div class="custom-control custom-switch" id="customBtnSwitchDiv">
                        <input type="checkbox" class="custom-control-input" id="buttonAnimation"
                            [value]="animationButton" [checked]="animationButton" [(ngModel)]="animationButton" />
                        <label class="custom-control-label" for="buttonAnimation">
                            {{ animationButton ? enabled : disabled }}
                        </label>
                    </div>
                </div>
                <div class="check_groups" id="checkGroupsBtnFunctionDiv">
                    <legend class="col-form-label"><span i18n="@@settings.check-groups.button-functionality">Button
                            Functionality</span></legend>
                    <div class="form-check" id="customBtnFrmCheckDiv">
                        <input class="form-check-input" type="radio" id="deviceSpecs" [value]="deviceSpecifications"
                            [checked]="deviceSpecifications" name="BtnFunctionRadio"
                            (change)="updateSettingsFlags($event,'deviceSpecifications')" />
                        <label class="form-check-label" for="deviceSpecs">
                            <span i18n="@@settings.check-groups.explore-this-device">Explore this device</span>
                        </label>
                    </div>
                    <div class="form-check mt-2" id="customBtnLinkToUrlDiv">
                        <input class="form-check-input" type="radio" id="linkToURL" [value]="linkToURL"
                            [checked]="linkToURL" name="BtnFunctionRadio"
                            (change)="updateSettingsFlags($event,'linkToURL')" />
                        <label class="form-check-label" for="linkToURL">
                            <span i18n="@@settings.form-check-label.link-to-url">Link to URL</span>
                        </label>
                    </div>
                    <div class="mt-4" id="customizableButtonLinkToUrl">
                        {{linkToURL ?
                        linkToUrlInfo :
                        deviceSpecificationInfo
                        }}
                    </div>
                </div>
                <div class="check_groups" *ngIf="!linkToURL" id="checkGroupsButtonCopyDiv">
                    <legend class="col-form-label"><span i18n="@@settings.check-groups.button-copy">Button Copy</span>
                    </legend>
                    <div class="form-check" id="explorePcRadioDiv">
                        <input class="form-check-input" type="radio" name="BtnexploreThisPC" id="explorePCRadio"
                            [value]="exploreThisPC" [checked]="exploreThisPC"
                            (change)="updateSettingsFlags($event,'exploreThisPC')" />
                        <label class="form-check-label" for="explorePCRadio">
                            <span i18n="@@settings.form-check-label.explore">“Explore This PC”</span>
                        </label>
                    </div>
                    <div class="form-check mt-2" style="display: flex; align-items: center"
                        id="customButtonCopyTextDiv">
                        <input class="form-check-input" type="radio" name="BtnexploreThisPC" [value]="customBtnCopy"
                            [checked]="customBtnCopy" (change)="updateSettingsFlags($event,'customBtnCopy')" />
                        <input style="margin: 0px 8px" class="form-control" type="text" maxlength="20"
                            placeholder={{buttonCopyPlaceholderText}} id="customButtonCopyText"
                            [value]="customButtonCopyText" [(ngModel)]="customButtonCopyText"
                            [readonly]="!customBtnCopy" />
                    </div>
                </div>
                <div class="check_groups" *ngIf="linkToURL" id="checkGrpUrlCustomBtnDiv">
                    <div class="form-group" id="urlFormGroupDiv">
                        <label for="url">
                            <span i18n="@@settings.form-group.website-url">Website URL</span>
                            <span class="text-danger">*</span>
                        </label>
                        <input style="width: 60%;" class="form-control" type="text"
                            placeholder={{enterURLPlacholderText}} id="url" [value]="url" [(ngModel)]="url"
                            (keyup)="validateURL($event)" autocomplete="off" />
                        <span class="text-danger" *ngIf="!isURLValid" [innerHTML]='emailValidationMsg'></span>
                    </div>
                    <div class="form-group mt-2" id="customButtonCopyTextDiv">
                        <label for="customButtonCopyText">
                            <span i18n="@@settings.form-group.custom-button-copy">Custom Button Copy</span>
                            <span class="text-danger">*</span>
                        </label>
                        <input style="width: 60%;" class="form-control" type="text" maxlength="20"
                            placeholder={{buttonCopyPlaceholderText}} id="customButtonCopyText"
                            [value]="customButtonCopyText" [(ngModel)]="customButtonCopyText" />
                    </div>
                </div>
            </div>
            <figure class="figure">
                <img class="figure-img CP_settings_custom_btn" alt="custom btn eg." />
                <figcaption class="figure-caption">
                    <span i18n="@@settings.figure.example-info"><strong>Example: </strong>Customize if this button will
                        be clickable.</span>
                </figcaption>
            </figure>
        </div>
    </div>

    <!-- Settings: blocks end here -->
    <div class="button_wrapper" style="justify-content: flex-end" id="settingsButtonsDiv">
        <button type="button" class="btn btn-outline-primary btn-lg" (click)="sendToProfile('skip')">
            <span i18n="@@settings.button.skip">Skip</span>
        </button>
        <button type="button" class="btn btn-primary btn-lg gtmSaveSetting" (click)="sendToProfile('send')"
            [disabled]="((!customButtonCopyText.trim()?.length || !url.trim().length || !isURLValid) && linkToURL) || !compareNavigationText?.trim()?.length">
            <span class="gtmSaveSetting" i18n="@@settings.button.save-continue">Save and Continue</span>
        </button>
    </div>
    <!-- Using same component for change Mater/ Uninstall password popup-->
    <iposcen-change-password #profileChangePasswordModal (isMasterPwdChangged)="showMasterStatus($event)"
        (isUnInstallPwdChanged)="showUninstallStatus($event)"></iposcen-change-password>
    <div class="container" id="actionOnPendingUsers">
        <div class="modal-dialog-centered" *ngIf="messageModalPopup" id="actionOnPendingUsersModalDialogDiv">
            <div class="modal-backdrop show" id="actionOnPendingUsersModalBackDropShowDiv"></div>
            <div class="modal" id="myModal">
                <div class="modal-dialog" id="myModalModalDialogDiv">
                    <div class="modal-content" id="myModalContentDiv">
                        <div class="close" id="myModalCloseDiv" data-dismiss="modal" (click)="closeMessageModal()">
                            <img class="popup_close_button" alt="close" />
                        </div>
                        <div class="modal-body" id="myModalBodyDiv">
                            <div class="action_on_pending_user" id="myModalSuccessImgDiv">
                                <span class="success_img"></span>
                            </div>
                            <div class="action-success-msg" id="myModalActionSuccessMsgDiv">
                                <span i18n="@@settings.modal-content.password-updated">{{passwordType}} Password
                                    Updated</span>
                            </div>
                            <div class="on-action-recieved-msg" id="myModalOnActionRecievedMsgDiv">
                                <span i18n="@@settings.modal-content.password-updation-message">The {{passwordType}}
                                    password has been updated for this device.</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<iposcen-spinner-overlay *ngIf="isDataLoading"></iposcen-spinner-overlay>